import { useEffect, useState } from 'react';
import DropdownTO from '../../common/TO/DropdownTO';
import LinkService from '../../system/LinkService';
import useApiCall from '../../system/useApiCall';

export function useAvatarCategoryDropdownData() {
  const [data, setData] = useState<DropdownTO[]>([]);
  const apiCall = useApiCall();

  useEffect(() => {
    apiCall.get(LinkService.dropdownAvatarCategory()).then((resultData) => {
      if (resultData) {
        const list: DropdownTO[] = resultData;
        setData(list);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
}
